
import { Component, Inject, OnInit, DOCUMENT } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import $ from 'jquery';
import { environment } from '../../../environments/environment';
import { ROLE_CONSTANTS, ROLE_GROUP_CONSTANTS } from '../constants/role.constants';
import { RoleService } from '../constants/role.service';
@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss'],
	standalone: false
})
export class SidebarComponent implements OnInit {
	ROLE_CONSTANTS = ROLE_CONSTANTS;
	ROLE_GROUP_CONSTANTS = ROLE_GROUP_CONSTANTS;
	public menuItems: any = [];
	bucketurl = environment.bucketUrl;
	role_id: any;
	zone_id: any;
	activeUrl = '';
	biDashboardUrl = '';
	constructor(public roleService: RoleService, private router: Router, @Inject(DOCUMENT) private document: Document) {
		this.router.events.subscribe(() => {
			this.activeUrl = this.router.url;
		});
	}

	ngOnInit() {
		// page refresh / direct URL ke liye
		this.activeUrl = this.router.url;
		this.biDashboardUrl = `https://smipl-dashboard.glocal360.ai/lms/login/?token=${encodeURIComponent(sessionStorage.getItem('token') || '')}`;
		this.document.body.classList.add('logged-in-background');
		this.selectedTarget = this.router.url.split("/")[2]

		if (sessionStorage.getItem('loginResponse')) {
			const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
			if (loginResponse && loginResponse.data) {
				this.role_id = loginResponse.data?.user?.role_id;
				this.zone_id = loginResponse.data?.user?.zone_id;
			}
		}
		// route change ke baad sync
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.activeUrl = event.urlAfterRedirects;
			}
		});
	}
	onMenuClick(url: string) {
		this.activeUrl = url; // instant highlight
	}
	selectedTarget: any = ''
	setActive(TARGETNAME: any): void {
		this.selectedTarget = TARGETNAME;
		let spliedClass: any = document.getElementById(TARGETNAME)?.className.split(" ")
		if (spliedClass[2] == 'active' || spliedClass[3] == 'active') {
			document.getElementById(TARGETNAME)!.classList.remove("active");
		}
		else {
			document.getElementById(TARGETNAME)!.classList.add('active');
		}
	}

	isCollapsed: boolean = false;
	$: any;
	toggleSidebar() {
		this.isCollapsed = !this.isCollapsed;
		$("body").toggleClass("fullcontent");
	}

	openSubMenu: string | null = null;

	toggleSubMenu(menu: string) {
		this.openSubMenu = this.openSubMenu === menu ? null : menu;
	}

}
